export default {
  tenantSysManagement: [
    {
      path: '/userManagement',
      component: () => import('@/views/tenantSysManagement/userManagement/index.vue'),
      name: '用户管理',
      children: []
    },
    {
      path: '/roleManagement',
      component: () => import('@/views/tenantSysManagement/roleManagement/index.vue'),
      name: 'roleManagement',
      children: []
    },
    {
      path: '/dataDictionary',
      component: () => import('@/views/tenantSysManagement/dataDictionary/index.vue'),
      name: 'dataDictionary',
      children: []
    },
    {
      path: '/tenantPcMenu',
      component: () => import('@/views/tenantSysManagement/tenantPcMenu/index.vue'),
      name: 'tenantPcMenu',
      children: []
    },
    {
      path: '/tenantAppMenu',
      component: () => import('@/views/tenantSysManagement/tenantAppMenu/index.vue'),
      name: 'tenantAppMenu',
      children: []
    },
    {
      path: '/tenantWxMenu',
      component: () => import('@/views/tenantSysManagement/tenantWxMenu/index.vue'),
      name: 'tenantWxMenu',
      children: []
    },
    {
      path: '/tenantSystem',
      component: () => import('@/views/tenantSysManagement/tenantSystem/index.vue'),
      name: '系统管理',
      children: []
    },
    {
      path: '/logManage',
      component: () => import('@/views/tenantSysManagement/logManage/index.vue'),
      name: '日志管理',
      children: []
    },
    {
      path: '/templateManage',
      component: () => import('@/views/tenantSysManagement/templateManage/index.vue'),
      name: '模板管理',
      children: []
    },
    {
      path: '/usersGuide',
      component: () => import('@/views/tenantSysManagement/userGuide/index.vue'),
      name: '使用手册（各租户）',
      children: []
    },
    {
      path: '/tenantDataDictionary',
      component: () => import('@/views/tenantSysManagement/dataDictionary/index.vue'),
      name: '租户数据字典',
      children: []
    },
    {
      path: '/subManagement',
      component: () => import('@/views/tenantSysManagement/subManagement/index.vue'),
      name: '届次管理',
      children: []
    },
    {
      path: '/largeScreenMenu',
      component: () => import('@/views/tenantSysManagement/largeScreenMenu/index.vue'),
      name: '大屏菜单管理',
      children: []
    },
    {
      path: '/organizationManage',
      component: () => import('@/views/tenantSysManagement/organizationManage/index.vue'),
      name: '组织管理',
      children: []
    },
    {
      path: '/addressBook',
      component: () => import('@/views/tenantSysManagement/addressBook/index.vue'),
      name: '通讯录',
      children: []
    },
    {
      path: '/sensitiveManage',
      component: () => import('@/views/tenantSysManagement/sensitiveManage/index.vue'),
      name: '敏感词管理',
      children: []
    },
    {
      path: '/tenantSysManagement/customcolumns',
      component: () => import('@/views/subsystem/customcolumns/index.vue'),
      name: '自定义列-租户',
      children: []
    },
    {
      path: '/appletBlacklist',
      component: () => import('@/views/tenantSysManagement/appletBlacklist/index.vue'),
      name: '小程序黑名单',
      children: []
    },
    {
      path: '/frequentlyAskedQuestion',
      component: () => import('@/views/tenantSysManagement/frequentlyAskedQuestion/index.vue'),
      name: 'frequentlyAskedQuestion',
      children: []
    },
    {
      path: '/videoDemandPage',
      component: () => import('@/views/tenantSysManagement/videoDemandPage/index.vue'),
      name: '视频点播配置',
      children: []
    },
    {
      path: '/tenantSysManagement/aiAssistantPage',
      component: () => import('@/views/tenantSysManagement/aiAssistantPage/index.vue'),
      name: 'aiAssistantPage',
      children: []
    },
    {
      path: '/tenantSysManagement/authorizationManage',
      component: () => import('@/views/tenantSysManagement/authorizationManage/index.vue'),
      name: '授权管理',
      children: []
    },
    {
      path: '/tenantSysManagement/congratulatoryPage',
      component: () => import('@/views/tenantSysManagement/congratulatoryPage/index.vue'),
      name: '代表/委员祝贺配置',
      children: []
    }
  ]
}
